import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { t } from '@/i18n';
import type { TrainingMode } from '@/types/training';
import { MODE_CONFIG } from './modeConfig';
import { Ornament } from './Ornament';
import './ModeCard.css';

interface ModeCardProps {
  mode: TrainingMode;
  /** `large` shows the ornament and more breathing room. */
  size?: 'compact' | 'large';
}

export function ModeCard({ mode, size = 'compact' }: ModeCardProps) {
  const config = MODE_CONFIG[mode];
  const { Icon } = config;

  return (
    <Link to={config.to} className={`mode-card mode-card--${size}`}>
      {size === 'large' && <Ornament kind={config.ornament} size={110} />}
      <span className={`mode-card__badge mode-card__badge--${config.tone}`}>
        <Icon size={size === 'large' ? 30 : 24} aria-hidden="true" strokeWidth={2.2} />
      </span>
      <span className="mode-card__text">
        <span className="mode-card__title">{t(config.titleKey)}</span>
        <span className="mode-card__hint">{t(config.hintKey)}</span>
      </span>
      <ChevronRight className="mode-card__chevron" size={22} aria-hidden="true" />
    </Link>
  );
}
